import { render } from "./OnboardingDenied.vue?vue&type=template&id=7fa31124&ts=true"
import script from "./OnboardingDenied.vue?vue&type=script&lang=ts"
export * from "./OnboardingDenied.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__